import React, { useState } from "react";

const TermsConditions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  return (
    <div>
      <div
        onClick={openDialog}
        className="font-bold text-primary cursor-pointer"
      >
         Prepaid Booking Terms and Conditions
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center "
          onClick={closeDialog}
        >
          <div
            className="bg-white rounded-lg shadow-lg w-full max-w-xl max-h-[80%] overflow-scroll p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-xl font-bold mb-4 flex justify-between">
              <div>Booking Terms & Conditions</div>
              <div onClick={closeDialog} className="cursor-pointer">X</div>
            </div>

            <div className="text-gray-700 mb-6">
              <h1>1. Payment</h1>
              <p>All payments will be processed in Australian dollars.</p>
              <p>We accept a valid credit card, a Visa or MasterCard branded Debit Cards, as well as American Express, JCB, UnionPay, ApplePay and GooglePay (Nominated Cards). All online prepaid booking payments do not incur a credit card surcharge. Learn more about paying with your AMEX Reward Points.</p>
              <p>International credit cards may attract an International Transaction Fee from your financial institution.</p>
              <p>Please note, we do not accept cash for rental payment or for the rental security bond (as that term is defined in the Terms and Conditions (Rental Security Bond)). We do not accept pre-paid cards or vouchers for the Rental Security Bond.</p>
              <p>Please note, when picking up the vehicle, you must present an accepted form of payment.</p>

              <h2>1.1 Local Renter Policy</h2>
              <p>If this is the first time you are renting from us and you live within a 150 kilometre radius of the rental counter from which you are collecting the vehicle, you must provide a utility bill* no older than three months as proof of address. The residential address shown on the utility bill must match the address listed on your driver licence. A Rental Security Bond of $1000 is also required to secure the booking and a pre-authorisation will be processed using your Nominated Card.</p>
              <p>*A hard copy or digital version of the following utility bills are accepted forms of identification: electricity, gas, rates, water, phone and internet bills.</p>
              <p>Please note: if you have previously rented from us you are not required to provide a utility bill as proof of address.</p>

              <h2>1.2 Online Prepaid Bookings</h2>
              <p>All online prepaid booking payments do not incur a credit card surcharge. If you have purchased and prepaid your car rental on our website, the name and credit card details provided must be the same as the authorised driver on our rental agreement. Please ensure that you provide a valid Nominated Card and a drivers licence (both of which must be in the name given in the booking at time of collecting the vehicle).</p>

              <h2>1.3 Pay on Arrival Bookings</h2>
              <p>On collection of the rented vehicle, payment is required in full. This will include your car rental rate and any other services or options agreed to at the time (Payment Amount).</p>

              <h1>2. Cancellations and Refunds</h1>
              <h2>2.1 Prepaid Refunds</h2>
              <p>When booking directly with us and choosing any prepaid option, you accept the cancellation and refund terms of the booking, and the following associated fees:</p>
              <ul>
                <li>Cancelling the booking 7 or more days prior to the collection date of the vehicle will result in a full refund of the Payment Amount.</li>
                <li>When cancelling more than three (3) days but less than seven (7) days prior to the collection date, the cancellation fee will be equal to the sum of three (3) rental days as per the rental fee of the booking.</li>
                <li>When cancelling three (3) days or less prior to the collection date, the cancellation fee will be equal to the full Payment Amount.</li>
                <li>No refund will be provided on any portion of the Payment Amount if you fail to pick up the vehicle at the day and time of collection.</li>
                <li>No refund will be provided for ‘early returns’ or ‘unused days’ when returning the vehicle earlier than the booked dates and times.</li>
                <li>Any unused portion of the Optional Extras purchased at the time of collection will be refunded to you.</li>
              </ul>
              <p>Cancellations or amendments to the booking can only be made by phoning our Call Centre on 1800 028 881 or +61 (0)7 5555 8900.</p>
              <p>If you amend your booking, this may change the rates and fees which apply to your booking (and increase or decrease the cost of your booking). You will be informed of the change at the time of your amendment. By making the amendment, you agree to the change to the rates and fees that occurs as a result of the amendment. You will not be charged any separate or additional fee for making the amendment itself.</p>

              <h2>2.2 Pay on Arrival Refunds</h2>
              <p>No cancellation or refund fees apply when booking directly with East Coast Car Rentals and choosing the Pay Later option.</p>

              <h2>2.3 Refund payments on Nominated Card</h2>
              <p>Any refund we provide to you will be made using the same Nominated Card used for the Payment Amount. If the Nominated Card you used is no longer available, we may ask you to provide additional information regarding your identity, the Nominated Card used for payment and the account or card to which a refund is requested. A refund to Nominated Card that was not used to pay the Payment Amount, may be delayed by up to 7 days to enable us to protect against fraudulent refunds.</p>


            </div>

            <div className="flex justify-end">
              <button
                onClick={closeDialog}
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TermsConditions;